import { render, staticRenderFns } from "./PersonSetting.vue?vue&type=template&id=8fea949a&"
import script from "./PersonSetting.vue?vue&type=script&lang=js&"
export * from "./PersonSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports